<div class="flexie-auto-grid p-b-20">
    <div>
        <h3 translate>Search</h3>
        <app-ui-search [(SearchCriteria)]="CRITERIALOOKUP" (componentOutput)="fetchSearchResult($event)"
            searchURL="searchReceipt" itemsPerPage='1'></app-ui-search>
    </div>
    <div class="text-a-right">
        <button nz-button [nzType]="'primary'" (click)="newReceipt()" translate>
            <i nz-icon nzType="plus" nzTheme="outline"></i> New Receipt
        </button>
    </div>
</div>

<h3 class="heading" translate>Latest Receipts Worked On</h3>

<nz-table #receiptSearchTable [nzData]="dataSet" [nzSize]="'middle'" [nzTemplateMode]="showNoData">
  <thead>
    <tr>
      <th>Proposal Number</th>
      <th>Insured</th>
      <th>Received</th>
      <th>Creation Date</th>
      <th>Transaction Date</th>
      <th>Status</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of receiptSearchTable.data">
      <td>{{data.proposalNum}}</td>
      <td>{{data.firstName}} {{data.lastName}}</td>
      <td>{{ (data.amount |  CurrencyFormatter : (currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) )|| '-'}}</td>
      <td>{{getDateString(data.createdDt)  || '-'}}</td>
      <td>{{ data.transactionDt | date: appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR || '-' }}</td>
      <td>{{data.receiptStatusCd | technicalTranslate }}</td>
      <td><a (click)="viewReceipt(data.guid)">View Receipt</a></td>
    </tr>
  </tbody>
</nz-table>

<nz-modal [(nzVisible)]="showReceipt" [nzOkText]="null" nzTitle="Receipt" nzCancelText="Close" (nzOnCancel)="closeReceipt()" nzWidth="80%">
  <ng-container *nzModalContent>
    <app-view-receipt  [payloadData]="transactionDataIO" ></app-view-receipt>    
    </ng-container>
</nz-modal>